import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminProductFamiliesNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('product-family');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
